import PageRenderer from "../components/PageRenderer";

const Preisliste = () => <PageRenderer pageName="Preisliste" analyticsPath="/preisliste" />;

export default Preisliste;
